import Vue from 'vue'

Vue.use({
    install() {
        Vue.prototype.$loginCallback = function () {
            if(this.$route.query._token)
            {
                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: this.$route.query._token,
                    remember: true
                })

                // Fetch the user.
                this.$store.dispatch('auth/fetchUser')
            }

            if(this.$route.query.hasOwnProperty('error_n'))
            {
                this.$q.notify({
                    color: 'warning',
                    icon: 'warning',
                    message: this.$T(this.$route.query.message),
                    detail: "",
                    position: 'top'
                })

                setTimeout(function () {
                    window.location.href = '/';
                } , 120);
            } else {
                this.$router.replace({query: !this.$route.query.alias ? {} : {alias: this.$route.query.alias}});
            }
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/loginCallback.js